import styled from 'styled-components'

export const Button = styled.button`
  color: ${props => props.disabled ? '#FFFFFF' : props.$light ? '#FFC700' : props.$secondary ? '#1882FF' : props.$textColor};
  background: ${props => props.disabled ? '#E5E5E5' : props.$light ? 'white' : props.$secondary ? 'transparent' : props.$backgroundColor};
  font-weight: 700;
  font-size: ${props => props.$secondary ? '0.8rem' : '1rem'};
  line-height: 1.2rem;
  padding: ${props => props.$secondary ? '1rem' : '1rem 2rem'};
  min-width: ${props => props.$secondary ? 'auto' : '14rem'};
  border-radius: 7px;
  border: 1px solid ${props => props.disabled ? '#E5E5E5' : props.$light ? '#FFC700' : props.$secondary ? '#1882FF' : props.$backgroundColor};
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  outline: none;
  transition: background-color 300ms linear, color 300ms linear, border-color 300ms linear;

  &:focus {
    outline: none;
  }
  &:hover {
    background-color: ${props => props.disabled ? '#E5E5E5' : props.$light ? '#FFC700' : props.$secondary ? '#1882FF' : props.$hoverBackgroundColor};
    border: 1px solid ${props => props.disabled ? '#E5E5E5' : props.$light ? '#FFC700' : props.$secondary ? '#1882FF' : props.$hoverBackgroundColor};
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    color: ${props => props.$light ? 'white' : props.disabled ? 'white' : props.$secondary ? 'white' : props.$textColor};
  }
`

Button.defaultProps = {
  $textColor: 'white',
  $backgroundColor: '#FFC700',
  $hoverBackgroundColor: '#f4bb00'
}
